import React from 'react';
import './index.css';
import clsx from 'classnames';
import { useHistory } from 'react-router-dom';
import { ImageLoader } from 'components';

const ProductItem = (props) => {
  // lineNumuber 每行显示数量
  const { item, lineNumber = 3, currentPage, imageCacheKey } = props;
  const history = useHistory();

  // 跳转详情
  const goDetail = (v) => {
    const url =
      v?.cid === 'new'
        ? `/productCenter/${v.id}?isNew=true`
        : `/productCenter/${v.id}`;
    history.push(url);
  };

  const imgUrl = 'https://api.zjzyfwq.com' + item?.imgs[0]?.url.slice(4);
  return (
    <div
      className={clsx('product-center-content-right-content-item')}
      onClick={() => goDetail(item)}
      style={{ width: `calc(100% / ${lineNumber} - 20px)` }}
    >
      <div className={clsx('product-center-content-right-content-item-block')}>
        <ImageLoader
          src={imgUrl}
          alt={item.name}
          width={'100%'}
          height={'100%'}
          cacheKey={imageCacheKey}
          currentPage={currentPage}
          className='product-center-content-right-content-item-img'
        />
      </div>
      <div className={clsx('product-center-content-right-content-item-title')}>
        {item.model + item.name}
      </div>
    </div>
  );
};

export default ProductItem;
